/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const MediaExportJobEnqueueDtoTypeEnum = {
    AUDIO: "AUDIO",
    VIDEO: "VIDEO"
} as const;

export type MediaExportJobEnqueueDtoTypeEnumKey = (typeof MediaExportJobEnqueueDtoTypeEnum)[keyof typeof MediaExportJobEnqueueDtoTypeEnum];

/**
 * MediaExportJobEnqueueWithType
 * @description Body for enqueuing an export job.
*/
export type MediaExportJobEnqueueDto = {
    /**
     * @description Station identifier
     * @type string
    */
    stationId: string;
    /**
     * @description Media type (audio or video)
     * @type string
    */
    type: MediaExportJobEnqueueDtoTypeEnumKey;
    /**
     * @type string
    */
    from: string;
    /**
     * @type string
    */
    to: string;
};